<script setup lang="js">
import { whenever } from '@vueuse/core'

import ws from '~/apis/spotSocket'
import { useStore } from '~/store'
import { useUserStore } from '~/store/user'
import { useSpotStore } from '~/store/spot'
import { useUrlReplaceSymbol } from '~/hooks/spot'
import { useTDK } from '~/hooks/seo'

import FavSymbols from '~/components/spot/favSymbols/index.vue'
import TickerSymbol from '~/components/spot/TickerSymbol.vue'
import Chart from '~/components/spot/chart/index.vue'
import MarketDetail from '~/components/spot/MarketDetail.vue'
import Panel from '~/components/spot/Panel.vue'
import Order from '~/components/spot/Order.vue'
import Network from '~/components/spot/Network.vue'

definePageMeta({ hideFooter: true })

const store = useStore()
const spot = useSpotStore()
const user = useUserStore()
const route = useRoute()
const { t } = useI18n()
const urlReplaceSymbol = useUrlReplaceSymbol()

const title = computed(() => {
  const { lp, code } = spot.overview
  return t('{0} | {1} 即时现货交易价格走势图 | TT', [lp, code])
})
const description = computed(() => t('{0}现货交易首选，体验即时价格图表、低手续费与无缝交易执行，立即在 TT 开启您的交易之旅！', [spot.curInfo.displayName]))
useTDK({
  title,
  description,
})

spot.getOverview()
spot.getSpotCurrency()
ws.subscribe('!@ticker')

watch([() => route.params.symbol, () => store.symbols], () => {
  if (!store.symbols.length)
    return

  const { symbol } = route.params
  if (!store.symbolsRaw[symbol]) {
    urlReplaceSymbol(spot.defaultCode)
  }
  else {
    spot.code = symbol
  }
}, {
  immediate: true,
})

watch(() => spot.id, (nv, ov) => {
  if (ov !== nv) {
    if (ov) {
      // 取消订阅
      ws.unsubscribe(`${ov}@trade`)
      // ws.unsubscribe(`${ov}@snapshot_depth@20@${spot.step}`)
      ws.unsubscribe(`${ov}@depth@100@depth`)
    }

    if (nv) {
      spot.step = spot.steps?.[0]
      ws.subscribe(`${nv}@trade`) // 最新成交
      // ws.subscribe(`${nv}@snapshot_depth@20@${spot.step}`) // 订单薄
      ws.subscribe(`${nv}@depth@100@depth`) // 深度
    }
  }
}, { immediate: true })

whenever(() => user.isLogin, () => {
  store.loadFav()
  ws.subscribe(`spot_asset`)
  spot.loadFavSymbols()
}, { immediate: true })
</script>

<template>
  <section class="bg-pageTertiary pb-[23px]">
    <FavSymbols />
    <TickerSymbol />
    <div class="flex py-0.5 space-x-0.5 rtl:flex-row-reverse">
      <div class="flex-1 space-y-0.5">
        <div class="flex space-x-0.5 rtl:flex-row-reverse h-[488px]">
          <Chart />
          <MarketDetail />
        </div>
        <Order />
      </div>
      <Panel />
    </div>
    <Network />
  </section>
</template>
